import axios from 'axios';

export const getNLocal = async (keyword) => {
  let url = `/api/ncoffee/${keyword}`;
  console.log('[getNLocal]', keyword);
  let res = await axios.get(url);
  return res;
};
